// Helper to ensure required headers are pressent and resolves x-is-mobile
export const getRequestHeaders = (isMobile, additionalHeaders = {}) => Object.assign({
  'x-model-version': '4',
  'x-is-mobile': isMobile ? 'Y' : 'N'
}, additionalHeaders);